export default "__VITE_ASSET__CSIUEL0g__"